import React, { useEffect, useState } from "react";
import DesktopMenu from "../../../../../common/DesktopMenu/index";
import MobileMenu from "../../../../../common/MobileMenu/index";
import useWindowSize from "../../../../../common/windowSize";
import NewFooter from "../../../../../common/NewFooter";
import { Background } from "../../../../../common/Faq/styles";
import { useTranslation } from "react-i18next";
import checkMark from "../../../../../assets/checkmark.png";
import { useNavigate } from "react-router-dom";
import { LoginButton } from "../../../../Login/styles";

const PaymentShipment = () => {
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? (
        <MobileMenu single={true} />
      ) : (
        <DesktopMenu single={true} />
      )}
      <Background marginTop adminPanel>
        <img src={checkMark} style={{ maxWidth: '250px', marginBottom: '50px' }} alt="Green check mark"/>
        <h2 style={{ color: '#1b2c58', marginBottom: '25px', textAlign: 'center' }}>
          {t('yourOrderHasBeenCreated')}
        </h2>
        <h3 style={{ color: 'gray', maxWidth: '400px', textAlign: 'center', marginBottom: '50px' }}>
          {t('weWillContactOrder')}
        </h3>
        <LoginButton 
            type="submit"
            onClick={() => navigate('/shop')}
            style={{ width: '100px' }}
            >
            Shop now
          </LoginButton>
      </Background>
      <NewFooter />
    </React.Fragment>
  );
};

export default PaymentShipment;
